export class Choices {
    name: string;
    value: string | number | boolean;
    group?: string;
}